export default __webpack_public_path__ + "static/media/html5.62a3bfbc.svg";